import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'League';

const LeagueApi: any = baseApi(endpoint);

export default LeagueApi;